import * as FfpInfoNotice from './components/FfpInfoNotice.css';
import * as SureModal from './components/SureModal/SureModal.css';
export default {
    FfpInfoNotice,
    SureModal
};
